import history from '../history';
import { Router, Switch, Route } from 'react-router-dom';
import { RouteWithLayout } from './RouteWithLayout';
import NotFoundPage from 'components/SharedComponents/NotFound/NotFound';

export default function Routes(props: { routeConfigAdminLayout: any[] }) {
  return (
    <Router history={history}>
      <Switch>
        {props.routeConfigAdminLayout.map((route, i) => {
          if (route.layout) return <RouteWithLayout key={i} layout={route.layout} exact path={route.path} component={route.component} />;
          return <Route key={i} exact path={route.path} component={route.component} />;
        })}
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </Router>
  );
}
